<template>
    <AppMainDialogForm v-model="dialog" :isLoading="isLoading" size='1000' :tituloTela="tituloTela" :tooltip="tooltip" 
        @initComponent="initComponent" @saveRegistro="saveRegistro" @cancel="cancel">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs11 md5>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdFarmaco" :items="farmacos" clearable
                        color="primary" item-text="nmNome" item-value="idFarmaco" label="Tipo" outlined>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 md3>
                    <SelectDate :rules="[campoObrigatorio, validarData]" label="Início da Vigência" v-model="registro.dtInicioVigencia"></SelectDate>
                </v-flex>
                <v-flex class="item" xs11 md3>
                    <SelectDate :rules="[validarData]" label="Fim da Vigência" v-model="registro.dtFimVigencia"></SelectDate>
                </v-flex>
            </v-layout>
        </v-form>
    </AppMainDialogForm>
</template>

<script>
    import { campoObrigatorio, campoSelectObrigatorio, validarData, data1InferiroData2 } from '@/filters/rules'

    import AppMainDialogForm from '@/components/layout/AppMainDialogForm.vue'
    import SelectDate from '@/components/general/SelectDate.vue'
    import { dateLocalToIso, dateIsoToLocal } from '@/filters/utils'

    export default {
        components: {
            AppMainDialogForm,
            SelectDate,
        },
        computed: {
            farmacos () {
                return this.$store.state.farmacos
            }
        },
        data () {
            return {
                tooltip: 'Medicamento',
                tituloTela: 'Inclusão de Medicamento',
                isFormValid: true,
                isLoading: false,
                isInserting: true,
                registro: {},
                idFarmaco: 0,
            }
        },
        methods: {
            campoObrigatorio,
            campoSelectObrigatorio,
            dateLocalToIso,
            dateIsoToLocal,
            validarData,
            data1InferiroData2,
            initComponent() {
                this.$emit('openDialog')
                var racaoFarmaco = {}
                if (this.rec.cdFarmaco != undefined)
                {
                    this.rec.dtInicioVigencia = this.dateIsoToLocal(this.rec.dtInicioVigencia)
                    this.rec.dtFimVigencia = this.rec.dtFimVigencia != null ? this.dateIsoToLocal(this.rec.dtFimVigencia) : ''
                    racaoFarmaco = this.rec
                    this.isInserting = false
                }
                else
                {   
                    if (this.$refs.form != undefined)
                    {
                        this.$refs.form.reset()
                    }
                    this.isInserting = true
                    racaoFarmaco = {
                        cdFarmaco: '',
                        dtInicioVigencia: '',
                        dtFimVigencia: ''
                    }
                }
                this.registro = Object.assign({}, racaoFarmaco)
            },
            saveRegistro() {
                if (this.$refs.form.validate())
                {
                    this.isLoading = true
                    if (this.isInserting)
                    {
                        this.insertRegistro()
                    }
                    else
                    {
                        this.updateRegistro()
                    }
                    this.isLoading = false
                }
            },
            insertRegistro() {
                if (this.registro.dtFimVigencia == "" || data1InferiroData2(this.dateLocalToIso(this.registro.dtInicioVigencia), this.dateLocalToIso(this.registro.dtFimVigencia)))
                {
                    this.rec.cdFarmaco = this.registro.cdFarmaco
                    this.rec.dtInicioVigencia = this.dateLocalToIso(this.registro.dtInicioVigencia)
                    this.rec.dtFimVigencia = this.registro.dtFimVigencia != '' ? this.dateLocalToIso(this.registro.dtFimVigencia) : null
                    this.rec.farmaco = this.farmacos.find(i => i.idFarmaco === this.registro.cdFarmaco )
                    this.$emit('inserted', this.rec)
                    this.$emit('closeDialog')
                }
                else
                {
                    this.$store.commit('setSnack', {type: 'error', msg : 'A data de inicio da vigência deve ser inferior a data de fim da vigência!'})
                }
            },
            updateRegistro() {
                if (this.registro.dtFimVigencia == "" || data1InferiroData2(this.dateLocalToIso(this.registro.dtInicioVigencia), this.dateLocalToIso(this.registro.dtFimVigencia)))
                {
                    this.rec.cdFarmaco = this.registro.cdFarmaco
                    this.rec.dtInicioVigencia = this.dateLocalToIso(this.registro.dtInicioVigencia)
                    this.rec.dtFimVigencia = this.registro.dtFimVigencia != '' ? this.dateLocalToIso(this.registro.dtFimVigencia) : null
                    this.rec.farmaco = this.farmacos.find(i => i.idFarmaco === this.registro.cdFarmaco )
                    this.$emit('updated', this.rec)
                    this.$emit('closeDialog')
                }
                else
                {
                    this.$store.commit('setSnack', {type: 'error', msg : 'A data de inicio da vigência deve ser inferior a data de fim da vigência!'})
                }
            },
            cancel() {
                this.$emit('closeDialog')
            },
        },
        props: {
            idRacao: Number,
            dialog: {
                type: Boolean,
                default: false
            },
            rec: {
                type: Object,
                default: () => ({})
            },
        },
        watch: {
            'dialog' (newValue, oldValue) {
                if (newValue && !oldValue)
                {
                    this.initComponent()
                }
            }
        }
    }
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
